import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Cab } from "../../Global Icons/Cab.svg";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCountryListPagination,
  viewStateListPagination,
  viewCityList,
} from "../../Redux/Actions/settingsActions";
import { addFinancePartner } from "../../Redux/Actions/financePartnersActions";
import { ScrollTop } from "../../Utils/helpers";
import toast from "react-hot-toast";
import TwoButtons from "../../Global Functions/buttons";
import AddImage from "../../Global Functions/addImage";
import "../Franchise/addFranchise.css";
import { PhonecodeSelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";

const AddFinancePartner = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { user } = useSelector((state) => state.auth || {});
  const [aboutError, setAboutError] = useState("");
  const [addressError, setAddressError] = useState("");

  const [formState, setFormState] = useState({
    company_name: "",
    logo: "",
    country_code: "",
    contact_number: "",
    address: "",
    about: "",
    country: "",
    state: "",
    city: "",
    status: "active",
  });

  const [logoPreview, setLogoPreview] = useState(null);

  useEffect(() => {
    ScrollTop();
    dispatch(viewCountryListPagination());
  }, [dispatch]);

  useEffect(() => {
    if (formState.country) {
      dispatch(viewStateListPagination({ country: formState.country }));
      setFormState((prev) => ({ ...prev, state: "", city: "" }));
    }
  }, [formState.country, dispatch]);

  useEffect(() => {
    if (formState.state) {
      dispatch(viewCityList({ state: formState.state, page: 1, limit: 100 }));
      setFormState((prev) => ({ ...prev, city: "" }));
    }
  }, [formState.state, dispatch]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "contact_number") {
      // Allow only digits in contact_number input
      if (/^\d*$/.test(value)) {
        setFormState((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    } else if (name === "about") {
      if (value.length <= 250) {
        setFormState((prev) => ({
          ...prev,
          [name]: value,
        }));
        setAboutError("");
      } else {
        setAboutError("Only 250 characters allowed");
      }
    } else if (name === "address") {
      if (value.length <= 250) {
        setFormState((prev) => ({
          ...prev,
          [name]: value,
        }));
        setAddressError("");
      } else {
        setAddressError("Only 250 characters allowed");
      }
    } else {
      setFormState((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Allowed MIME types for .png, .jpg, .jpeg
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];

    if (!validTypes.includes(file.type)) {
      toast.error(
        "Invalid file type. Please upload a .png, .jpg, or .jpeg image only."
      );
      event.target.value = ""; // Clear invalid file input
      return;
    }

    try {
      const uploadedUrl = await AddImage(file);
      if (uploadedUrl) {
        setFormState((prev) => ({ ...prev, logo: uploadedUrl }));
        setLogoPreview(uploadedUrl);
      }
    } catch (error) {
      toast.error("Image upload failed");
    }
  };

  const handleSubmit = async () => {
    if (!formState.company_name) {
      return toast.error("Company Name is required.");
    }
    if (!formState.logo) {
      return toast.error("Logo is required.");
    }
    if (!formState.country_code) {
      return toast.error("Country Code is required.");
    }
    if (!formState.contact_number) {
      return toast.error("Contact Number is required.");
    }
    if (!formState.address) {
      return toast.error("Address is required.");
    }
    if (!formState.country) {
      return toast.error("Country is required.");
    }
    if (!formState.state) {
      return toast.error("State is required.");
    }
    if (!formState.city) {
      return toast.error("City is required.");
    }

    const payload = {
      ...formState,
      company_name_withoutspace: formState.company_name.replace(/\s+/g, ""),
      created_by: user?.id || user?._id || "defaultAdminId",
    };

    try {
      const response = await dispatch(addFinancePartner(payload));
      if (response.statusCode === 200) {
        toast.success("Finance partner added successfully");
        navigate("/finance_partners");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Submit failed");
    }
  };

  return (
    <MainLayout>
      <div className="franchise-form-container">
        <div className="franchise-form-wrapper franchise-card">
          <div className="franchise-card-content">
            <div className="franchise-header">
              <div className="franchise-header-icon">
                <Cab />
              </div>
              <h1>Add Finance Partner</h1>
            </div>

            <div className="form-section">
              <TextInput
                label="Company Name"
                name="company_name"
                value={formState.company_name}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section">
              <label
                className="form-label file-upload-area"
                htmlFor="logo_input"
              >
                Logo<span style={{ color: "red" }}>*</span>
                <input
                  id="logo_input"
                  type="file"
                  name="logo"
                  accept=".png,.jpg,.jpeg"
                  onChange={handleFileChange}
                  className="form-input"
                />
              </label>
              {logoPreview && (
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={logoPreview}
                    alt="Logo Preview"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "150px",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              )}
            </div>

            <div className="form-section">
              <label className="form-label">Country Code<span style={{ color: "red" }}>*</span></label>
              <PhonecodeSelect
                placeHolder="Select Country Code"
                value={formState.country_code || ""}
                onChange={(country) => {
                  if (country && country.phone_code) {
                    const codeWithPlus = country.phone_code.startsWith("+")
                      ? country.phone_code
                      : "+" + country.phone_code;
                    setFormState((prev) => ({
                      ...prev,
                      country_code: codeWithPlus,
                    }));
                  } else {
                    setFormState((prev) => ({
                      ...prev,
                      country_code: "",
                    }));
                  }
                }}
                disabled={false}
              />
            </div>

            <div className="form-section">
              <TextInput
                label="Contact Number"
                name="contact_number"
                value={formState.contact_number}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section">
              <TextInput
                label="Address"
                name="address"
                value={formState.address}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
              {addressError && (
                <p style={{ color: "red", marginTop: "5px" }}>{addressError}</p>
              )}
            </div>

            <div className="form-section">
              <TextInput
                label="About"
                name="about"
                value={formState.about}
                onChange={handleChange}
                inputClass="form-input"
                labelClass="form-label"
                textarea
                rows={4}
              />
              {aboutError && (
                <p style={{ color: "red", marginTop: "5px" }}>{aboutError}</p>
              )}
            </div>

            <div className="form-section form-grid-3">
              <SelectInput
                label={<span>
                  Country<span style={{ color: "red" }}>*</span>
                </span>}
                name="country"
                value={formState.country}
                onChange={handleChange}
                // required
                options={
                  Array.isArray(countryList?.data)
                    ? countryList.data.map((c) => ({
                      label: c.country_name,
                      value: c._id,
                    }))
                    : []
                }
                selectClass="form-input"
                labelClass="form-label"
              />

              <SelectInput
                label={<span>
                  State<span style={{ color: "red" }}>*</span>
                </span>}
                name="state"
                value={formState.state}
                onChange={handleChange}
                // required
                disabled={!formState.country}
                options={
                  Array.isArray(states?.data)
                    ? states.data.map((s) => ({
                      label: s.state_name,
                      value: s._id,
                    }))
                    : []
                }
                selectClass="form-input"
                labelClass="form-label"
              />

              <SelectInput
                label={<span>
                  City<span style={{ color: "red" }}>*</span>
                </span>}
                name="city"
                value={formState.city}
                onChange={handleChange}
                // required
                disabled={!formState.state}
                options={
                  Array.isArray(cities?.data)
                    ? cities.data.map((c) => ({
                      label: c.city_name,
                      value: c._id,
                    }))
                    : []
                }
                selectClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-navigation">
              <TwoButtons
                buttonHead1="Cancel"
                noUrl={true}
                LinkURL="/finance_partners"
                onClick2={handleSubmit}
                buttonHead2="Save"
              />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddFinancePartner;
